
export const classStatus = {
    ONPLACE:"در مجموعه",
    ONLINE:"آنلاین"
}
